import { mapState } from 'vuex'
import { pushDataLayerEvent } from '@/modules/services/gtm'

const variantUtil = {
  computed: {
    ...mapState({
      currentUser: state => state.user.currentUser
    }),

    variantData () {
      return this.variant || this.currentVariant
    },

    launchConfig () {
      return this.variantData?.attributes['launch-config']
    },

    launchStatus () {
      return this.variantData?.attributes['launch-status']
    },

    isSupportedPlatform () {
      return !!(this.launchConfig?.prelaunch?.platforms?.includes(vueSupport.platform))
    },

    // If the prelaunch phase does not exist, all users will be non-qualified.
    isQualifiedUser () {
      return !!(this.launchConfig?.prelaunch?.tiers?.includes(this.currentUser?.attributes?.['loyalty-tier']))
    },

    isEarlyAccessEnabled () {
      return this.$kameleoon?.isFeatureFlagActive('enable_early_access') && !!this.launchConfig && this.launchStatus !== 'postlaunch'
    },

    isPreviewPhase () {
      return this.launchStatus === 'preview' || (this.isPrelaunch && !this.isQualifiedUser)
    },

    isPrelaunchPhaseExist () {
      return Object.keys(this.launchConfig.prelaunch).length > 0
    },

    isPrelaunch () {
      return this.launchStatus === 'prelaunch'
    },

    isEarlyAccessVariantIneligible () {
      return this.isEarlyAccessEnabled && (this.isPreviewPhase || (this.isPrelaunch && !this.isSupportedPlatform && !this.variantData?.attributes['sold-out']))
    },

    trackingParams () {
      return {
        variant_id: this.variantData.id,
        product_id: this.product.id,
        status: this.launchStatus,
        filter_type: this.earlyAccessBadge('lng_en')
      }
    }
  },

  methods: {
    earlyAccessBadge (language = I18n.language) {
      if (this.launchStatus === 'postlaunch') return ''

      const key = this.isPreviewPhase ? 'early_access.comingSoon' : 'early_access.priorityAccess'

      return this.$t(key, language)
    },

    recordGTMEvent (eventName, params = {}) {
      pushDataLayerEvent(
        eventName, {
          params: {
            ...this.trackingParams,
            ...params
          }
        }
      )
    }
  }
}

export { variantUtil }
